import * as WEBSITES from './website';

export const category = [
  {
    icon: 'icon-home',
    title: 'Home',
    path: '/'
  },
  {
    icon: '',
    title: 'Categories',
    path: '/categories'
  }
];
export const shop = [
  {
    icon: 'icon-home',
    title: 'Home',
    path: '/'
  },
  {
    icon: '',
    title: 'Shop',
    path: ''
  }
];
export const home = [
  {
    icon: 'icon-home',
    title: 'Home',
    path: '/'
  }
];
export const brand = [
  {
    icon: 'icon-home',
    title: 'Home',
    path: '/'
  },
  {
    icon: '',
    title: 'Brands',
    path: '/brands'
  }
];

export const weedDeliveryCities = [
  {
    icon: 'icon-home',
    title: 'Home',
    path: '/'
  },
  {
    icon: '',
    title: process.env.NEXT_PUBLIC_APP === WEBSITES.BENTO ? 'Weed Delivery Near Me' : 'Weed Delivery Near',
    path: process.env.NEXT_PUBLIC_APP === WEBSITES.BENTO ? '/weed-delivery-near-me' : '/weed-delivery-near'
  }
];

export const topSellersHub = [
  {
    icon: 'icon-home',
    title: 'Home',
    path: '/'
  },
  {
    icon: '',
    title: 'Top Sellers Hub',
    path: '/top-sellers-hub'
  }
]

export const getCityPath = path => {
  return path.substring(path.indexOf('/') + 1).replace(/-/g, ' ');
};
